import React from 'react';
import Typography from "@mui/material/Typography";


type ContentTitlesProps = {
    title?: string;
    subTitle?: string;
    overline?: string;
    style?: 'white';
    titleVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'subtitle1' | 'subtitle2' | 'body1' | 'body2' | 'caption' | 'button' | 'overline' | 'inherit';
    titleComponent?: React.ElementType;
    subTitleVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'subtitle1' | 'subtitle2' | 'body1' | 'body2' | 'caption' | 'button' | 'overline' | 'inherit';
    subTitleComponent?: React.ElementType;
    scrambleTitle?: boolean;
}

const ContentTitles: React.FC<ContentTitlesProps> = ({
                                                         overline,
                                                         title,
                                                         subTitle,
                                                         style,
                                                         titleVariant = 'h2',
                                                         titleComponent = 'h3',
                                                         subTitleComponent = 'h6',
                                                         subTitleVariant = 'h6',
                                                         scrambleTitle = false,
                                                     }) => {

    const OVERRIDE_STYLES = {
        white: {
            color: 'white',
            textShadow: '0 1px 3px rgba(0, 0, 0, 0.8)'
        }
    }

    const overrideStyle = style ? OVERRIDE_STYLES[style] : {};

    return (
        <div>
            {overline && (
                <Typography component='h6' variant='h6' align="center" sx={{p: 0, mb: 0, ...overrideStyle}}
                            >
                    {overline}
                </Typography>
            )}
            {title &&
                <Typography
                    variant={titleVariant}
                    component={titleComponent}
                    sx={{...overrideStyle}}
                    align="center"
                    className={`slide-right ${scrambleTitle ? 'scramble-text' : ''}`}
                >
                    {title}
                </Typography>}
            {subTitle && <Typography variant={subTitleVariant} component={subTitleComponent} sx={{...overrideStyle}}
                                     align="center"
                                     >
                {subTitle}
            </Typography>}
        </div>
    );
};

export default ContentTitles;
